export default __webpack_public_path__ + "static/media/Remolquede SúperLujo14.46fd177f.png";